enum LoginTypeEnum {
    BasbusManager,
    TrackingManager
}

export default LoginTypeEnum;